const isSolvableValidationError = (validationError)=>validationError.__typename === 'SolvableValidationError'
;
const getSolvableValidationErrors = (validationInput)=>{
    if (!validationInput || !validationInput.cartLineItemErrors) {
        return [];
    }
    /** The backend returns a hypothetical cart including the to-be-added lineItem with mockID and it's errors. We don't want to take action on them. */ const lineItemValidationErrors = validationInput.cartLineItemErrors.filter((error)=>error.itemId !== 'mockID'
    );
    if (lineItemValidationErrors) {
        return reduceErrorsToSingleArray(lineItemValidationErrors);
    }
    return [];
};
const reduceErrorsToSingleArray = (lineItemValidationErrors)=>{
    if (!lineItemValidationErrors) return [];
    const errors = lineItemValidationErrors.reduce((accumulator, currentValue)=>{
        const resolvableValidationError = currentValue.errors.map((error)=>{
            if (isSolvableValidationError(error)) {
                const { actionItem , defaultMessage , isSolvable , passed , validationCode  } = error;
                return {
                    actionItem,
                    defaultMessage,
                    isSolvable,
                    passed,
                    validationCode
                };
            }
        });
        return [
            ...accumulator,
            ...resolvableValidationError
        ];
    }, []);
    return errors.filter((error)=>!!error
    );
};

export { getSolvableValidationErrors };
//# sourceMappingURL=get-solvable-validation-errors.js.map
